import { forwardRef, PropsWithChildren } from 'react'
import cx from 'classnames'
import Styles from './IconButton.module.scss'

import { IconButtonProps } from './Types'
import { useHover } from '@react-aria/interactions'
import { useObjectRef } from 'utils/useObjectRef'
import { Button } from 'components/Button/Button'
import { mergeProps } from '@react-aria/utils'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

/*
 * A button that renders only an icon without any label.
 */
const IconButton = forwardRef<HTMLButtonElement, PropsWithChildren<IconButtonProps>>(
  ({ icon, children, className, active = false, variant = 'tertiary', size = 'sm', ...props }, fRef) => {
    const ref = useObjectRef<HTMLButtonElement>(fRef)
    const { isMobile } = useResponsiveDesign()
    const { isDisabled, onHoverStart, onHoverEnd } = props
    const { hoverProps } = useHover({
      isDisabled,
      onHoverStart,
      onHoverEnd,
    })

    return (
      <Button
        aria-label={props.title}
        {...mergeProps(props, hoverProps)}
        className={cx(Styles.root, Styles.iconButton, Styles[size], className)}
        variant={variant}
        forceActive={active}
        size={size}
        ref={ref}
        frontIcon={children ? undefined : icon}
        preventFocusOnPress={isMobile || props.preventFocusOnPress}
      >
        {icon ? null : children}
      </Button>
    )
  },
)

export { IconButton }
